<template>
  <div class="homepage dark:bg-purple-600">
    <div class="hidden md:block">
      <CarletonFooter />
    </div>
    <div v-if="urlFlag"><CrisisModal /></div>
    <div v-on:click="darkModeToggle()" class="cursor-pointer">
      <div v-if="darkSide">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="absolute top-0 right-0 z-50 m-6"
        >
          <circle cx="16" cy="16" r="16" fill="#E3E1FA" />
          <path
            d="M15.413 10.0217V8M15.413 23.5V21.4783M10.0795 21.6178L11.5091 20.1882M19.5143 11.5091L20.9439 10.0796M19.3169 20.1882L20.7465 21.6178M9.8821 10.0796L11.3117 11.5091M8 16.087H10.0217M21.4783 16.087H23.5"
            stroke="#3F3D56"
            stroke-linecap="round"
          />
          <circle cx="15.7501" cy="15.75" r="4.71739" fill="#3F3D56" />
        </svg>
      </div>
      <div v-if="!darkSide">
        <svg
          class="absolute top-0 right-0 z-50 m-6"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16" cy="16" r="16" fill="#E3E1FA" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M23.9737 18.4014C24.0936 18.1359 23.7791 17.8967 23.5224 18.0367C22.5324 18.5766 21.3956 18.8837 20.1866 18.8837C16.3514 18.8837 13.2423 15.7934 13.2423 11.9814C13.2423 10.7043 13.5913 9.50814 14.1997 8.48209C14.3483 8.2314 14.1174 7.91173 13.8467 8.02263C11.0022 9.18811 9 11.9713 9 15.2192C9 19.5164 12.5048 23 16.8281 23C20.0108 23 22.7499 21.1121 23.9737 18.4014Z"
            fill="#3F3D56"
          />
        </svg>
      </div>
    </div>

    <div class="mobileViewHideHomepage">
      <div class="topRowInfo">
        <div class="section2">
          <QuestionFooter />
        </div>
      </div>
      <div class="imageMaintain">
        <div v-if="!darkSide">
          <img
            src="./images/road_map_mobile.png"
            alt="Wellness Navigator Hero Illustration for mobile screens"
          />
        </div>
        <div v-else-if="darkSide">
          <!-- error in dev build , cannot find this image -->
          <img
            src="./images/lander_darkMode.png"
            alt="Wellness Navigator Hero Illustration for mobile screens"
          />
        </div>
      </div>

      <h1 class="subTitleMobile dark:text-white">
        What is the wellness navigator?
      </h1>
      <p class="paragraphseMobile mt-2 mb-4 dark:text-white">
        The Wellness Services Navigator is designed to help navigate Carleton
        students to a curated list of mental health and wellness resources. If
        you need to talk to someone,
        <a
          href="https://wellness.carleton.ca/get-help-now/"
          target="_blank"
          class="text-link-blue font-bold pb-0 dark:text-link-light-blue"
          >please reach out for assistance</a
        >.
      </p>
      <div v-on:click="startNavigator">
        <button
          class="nextButtonHomepageMobile cursor-pointer"
          aria-label="Get Started"
        >
          Get Started
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
      <br />
      <InfoDialog />
    </div>
    <div class="block md:hidden">
      <CarletonFooter />
    </div>

    <div class="column dark:bg-purple-600 conditionalPadding">
      <div class="rowForColumn1">
        <div class="footerRowInfo dark:bg-purple-600">
          <div class="footer1Desktop">
            <div v-if="!darkSide">
              <img
                src="./images/logo2x.png"
                class="footerPicDesktop"
                alt="Carleton University Logo"
              />
            </div>
            <div v-if="darkSide">
              <img
                src="./images/cu-logoDarkMode.svg"
                class="footerPicDesktop"
                alt="Carleton University Logo"
              />
            </div>
          </div>
          <div class="verticalBar"></div>
          <div class="footer2 dark:text-white">
            <div class="textForFooterDesktop" style="min-width: 141px">
              Mental Health <br />and Wellness
            </div>
          </div>
        </div>
      </div>

      <div class="rowForColumn2">
        <h2 class="titles dark:text-white">Wellness Services Navigator</h2>
        <p class="paragraphs mt-4 dark:text-white">
          The Wellness Services Navigator is designed to help navigate Carleton
          students to a curated list of mental health and wellness resources. If
          you need to talk to someone,
          <a
            href="https://wellness.carleton.ca/get-help-now/"
            target="_blank"
            class="text-link-blue font-bold pb-0 dark:text-link-light-blue"
            >please reach out for assistance</a
          >.
        </p>
        <div v-on:click="startNavigator">
          <button class="nextButtonHomepage" aria-label="Get Started">
            Get Started
            <span class="arrow">
              <svg
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                  fill="#8380A8"
                />
              </svg>
            </span>
          </button>
        </div>
        <br />

        <InfoDialog />
      </div>
    </div>

    <div v-if="darkSide" class="column2 heroDarkMode dark:bg-hero-purple"></div>

    <div v-if="!darkSide" class="column2 hero bg-hero-grey"></div>
  </div>
</template>

<script>
import InfoDialog from "./InfoDialog.vue";
import QuestionFooter from "./QuestionFooter.vue";
import CrisisModal from "./CrisisModal.vue";
// import Tooltip from "./Tooltip.vue";
import CarletonFooter from "./CarletonFooter.vue";
import store from "../store";
export default {
  data() {
    return {
      darkSide: false,
      urlFlag: false,
    };
  },

  components: {
    InfoDialog,
    CarletonFooter,
    QuestionFooter,
    CrisisModal,
  },

  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "home-page" });
      }
    },
    getURL() {
      if (window.location.href.indexOf("?crisis=true") != -1) {
        this.urlFlag = true;
      }
    },
    startNavigator() {
      store.commit("updatePage", '["questionOne"]');
    },
    checkDisplayMode() {
      if (localStorage.theme === "dark") {
        document.documentElement.classList.add("dark");
        this.darkSide = true;
        store.commit("changeDarkMode", this.darkSide);
      } else {
        document.documentElement.classList.remove("dark");
        this.darkSide = false;
        store.commit("changeDarkMode", this.darkSide);
      }
    },
    darkModeToggle() {
      store.commit("changeDarkModeSwap");
      const currMode = store.getters.darkModeState;
      this.darkSide = !this.darkSide;
      let classClass = "";
      if (currMode) {
        classClass = "dark";
        localStorage.theme = "dark";
      } else {
        classClass = "";
        localStorage.removeItem("theme");
      }
      var root = document.getElementsByTagName("html")[0];
      root.setAttribute("class", classClass);
    },
  },
  mounted() {
    this.checkDisplayMode();
    this.getURL();
    this.track();
  },
};
</script>

<style>
@import "../styles.css";
</style>
